import { Grommet } from "grommet-icons";
import {
   Typescript,
   Javascript,
   Firebase,
   MongoDB,
   Kotlin,
   Git,
   XCode,
   AndroidStudio,
   Java,
   Heroku,
   Swift,
   CSS,
   NodeJS,
   React as ReactIcon,
   Express,
} from "./TechnologySVGList";

export const projects = [
   {
      name: "NASA",
      url: "nasa.gov",
      roles: [{ name: "Internship", color: { color: "software-engineer", opacity: "strong" } }],
      period: "Incoming Fall 2026",
      img: "https://raw.githubusercontent.com/plaidroni/sevanevans.com/refs/heads/master/public/NASA_Wormball_logo.png",
      description: ``,
      techStack: [],
   },
   {
      name: "NASA M-STAR @ COD",
      url: "",
      roles: [{ name: "Student Researcher", color: { color: "co-founder", opacity: "strong" } }],
      period: "Mar 2026 - Present",
      img: "https://raw.githubusercontent.com/plaidroni/sevanevans.com/refs/heads/master/public/NASA_Wormball_logo.png",
      description: `
`,
      techStack: [],
   },

   {
      name: "NASA Community College Aerospace Scholars",
      url: "",
      roles: [{ name: "Voted Team MVP", color: { color: "co-founder", opacity: "strong" } }],
      period: "Jan 2026",
      img: "https://www.nasa.gov/wp-content/uploads/2023/03/edu_ncas_2018_patch_final-1041.png",
      description: `I recently had the pleasure of participating in NASA's Community College Aerospace Scholars Robotics Competition at College of the Desert.

The competition was an exceptional lesson in teamwork, adaptability, and systems thinking. As the competition neared its end, the team faced mounting pressure to design a claw with integrated sensors. Our initial design attempted to embed sensors into the claw, but the process took longer than anticipated, and we ran out of time before it could reliably grip objects. Rather than force a failing design, we pivoted to a plow, which required a rapid software update. With a minute left, we adapted the gyroscopic code to flip the targeted heading when an object was sensed and, despite having no time to test, placed the rover on the field for the final run—and thankfully, it worked amazingly. For my technical contributions, soft skills, and collaborative leadership, I was selected by our mentor as team MVP.
`,
      techStack: [],
   },
   {
      name: "UNIKE USA",
      url: "",
      roles: [{ name: "Consultant", color: { color: "software-engineer", opacity: "strong" } }],
      period: "Dec 2025 - Feb 2025",
      img: "https://unike.eu/wp-content/uploads/2023/05/unike_video_overlay.jpg",
      description: `Evaluate and document structured feedback on a series of computational fluid dynamics and engineering simulation software presentations, assessing technical clarity, use-case communication, and accessibility for both academic and industry audiences.
`,
      techStack: [],
   },
   {
      name: "Windtree Education",
      url: "",
      roles: [{ name: "STEM Teacher", color: { color: "software-engineer", opacity: "strong" } }],
      period: "Sept 2025 - May 2026",
      img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSbYkiacbF59c8bXU9mj_HrT7oDdIu2QMYMMA&s",
      description: `Introduce K–12 students to foundational engineering concepts using hands-on demonstrations and simplified physics experiments.
      
Communicate complex scientific principles clearly to students of varied experience levels.
`,
      techStack: [],
   },
   {
      name: "College Of The Desert",
      url: "",
      roles: [{ name: "Physics A.S.", color: { color: "physics-as", opacity: "strong" } }],
      period: "August 2024 - Expected Spring 2027",
      img: "https://raw.githubusercontent.com/plaidroni/sevanevans.com/refs/heads/master/public/COD.jpg",
      description: `During my Fall 2025 semester at College of the Desert, I founded and currently serve as President of the Physics Club. We have since grown to nearly 30 active members, have hosted multiple guest speakers from different fields, and organized several astronomy and physics-based field trips. In Spring 2026, we plan to fundraise, design, and engineer a small-scale rocket launch. I aim to inspire our members to pursue STEM and support their professional development by guiding them in creating personal online portfolios and connecting them with resources and school funding opportunities.`,
      techStack: [],
   },
   {
      name: "Tigase, Inc",
      url: "tigase.net",
      roles: [
         { name: "Software Engineer", color: { color: "software-engineer", opacity: "strong" } },
         { name: "Full-time", color: { color: "contract", opacity: "strong" } },
      ],
      period: "Jan 2021 - Sept 2024",
      techStack: [
         { name: "Java", icon: <Java /> },
         { name: "Swift", icon: <Swift /> },
         { name: "Kotlin", icon: <Kotlin /> },
         { name: "Git", icon: <Git /> },
         { name: "XCode", icon: <XCode /> },
         { name: "AndroidStudio", icon: <AndroidStudio /> },
      ],
      img: "https://raw.githubusercontent.com/plaidroni/sevanevans.com/refs/heads/master/public/tigase.png",
      description: `I am currently excelling in the creation of multi-platform applications using Kotlin and Swift for platforms including Android, iOS, MacOS, and Windows. My strengths lie in adapting swiftly to emerging technologies and grasping new concepts at a rapid pace. I have been working in close collaboration with graphic designers, which has empowered us to produce eye-catching illustrations. Furthermore, my work extends to the design of visual layout mockups, utilizing tools such as Adobe Photoshop and Illustrator. Notably, I am deeply involved in creating and overhauling application user experiences to align with modern standards, thereby successfully attracting new audiences.`,
   },
   {
      name: "Quick Draw",
      url: "",
      roles: [
         { name: "Software Engineer", color: { color: "software-engineer", opacity: "strong" } },
         { name: "Contract", color: { color: "contract", opacity: "strong" } },
      ],
      period: "Jan 2024 - Feb 2024",
      techStack: [
         { name: "Typescript", icon: <Typescript /> },
         { name: "CSS", icon: <CSS /> },
         { name: "React", icon: <ReactIcon /> },
      ],
      img: "https://raw.githubusercontent.com/plaidroni/sevanevans.com/refs/heads/master/public/quick_draw.jpg",
      description: ``,
   },
   {
      name: "BodyMX",
      url: "thebodymx.com",
      roles: [{ name: "Co-Founder", color: { color: "co-founder", opacity: "strong" } }],
      period: "Sept 2022 - April 2024",
      techStack: [
         { name: "Typescript", icon: <Typescript /> },
         { name: "Javascript", icon: <Javascript /> },
         { name: "CSS", icon: <CSS /> },
         { name: "Firebase", icon: <Firebase /> },
         { name: "Grommet", icon: <Grommet /> },
         { name: "MongoDB", icon: <MongoDB /> },
         { name: "NodeJS", icon: <NodeJS /> },
         { name: "Heroku", icon: <Heroku /> },
         { name: "React", icon: <ReactIcon /> },
         { name: "Express", icon: <Express /> },
      ],
      img: "",
      description: `As the Co-founder and Software Engineer of BodyMX, I've been creating a comprehensive digital platform that seamlessly connects fitness enthusiasts with trainers and wellness resources. Through innovation and determination, I've guided our team in designing an intuitive, responsive, and effective suite of fitness tools that benefit both users and professionals in the industry.
      
      In the creation of our website and mobile application, I leveraged a robust tech stack including React and TypeScript, alongside other cutting-edge technologies. React's reusable components and virtual DOM helped us craft a highly interactive user interface that not only runs smoothly but also makes for a delightful user experience. TypeScript, with its static typing, empowered us with better maintainability and debugging capabilities, resulting in safer and more reliable software.`,
   },
   // {
   //    name: "sevanevans.com",
   //    url: "sevanevans.com",
   //    roles: [{ name: "Project", color: { color: "software-engineer", opacity: "strong" } }],
   //    period: "July 2023",
   //    techStack: [
   //       { name: "Typescript", icon: <Typescript /> },
   //       { name: "Javascript", icon: <Javascript /> },
   //       { name: "CSS", icon: <CSS /> },
   //       { name: "React", icon: <ReactIcon /> },
   //    ],
   //    description: ``,
   // },
   {
      name: "PDHS Official Application",
      url: "",
      roles: [
         { name: "Collaborator", color: { color: "collaborator", opacity: "strong" } },
         { name: "Software Engineer", color: { color: "software-engineer", opacity: "strong" } },
      ],
      period: "2019",
      techStack: [
         { name: "Java", icon: <Java /> },
         { name: "Swift", icon: <Swift /> },
         { name: "Kotlin", icon: <Kotlin /> },
         { name: "Git", icon: <Git /> },
         { name: "XCode", icon: <XCode /> },
         { name: "AndroidStudio", icon: <AndroidStudio /> },
      ],
      img: "https://raw.githubusercontent.com/plaidroni/sevanevans.com/refs/heads/master/public/palm-desert-high.png",
      description: `During the PDHS Official School Application project, I developed crucial skills in cooperative problem-solving, communication, and rapid software development. As a collaborator, I contributed to a platform impacting students, teachers, and staff daily. Our challenge was maintaining consistent communication across the app's facets, which we overcame with modern development tools and a dedicated approach. This experience emphasized the importance of collaboration, precision, and user-centric design in real-world software development.`,
   },

   {
      name: "RCPC Hackathon",
      url: "",
      roles: [{ name: "1st Place", color: { color: "1st-place", opacity: "strong" } }],
      period: "Apr 2019",
      techStack: [{ name: "Java", icon: <Java /> }],
      img: "https://raw.githubusercontent.com/plaidroni/sevanevans.com/refs/heads/master/public/rcpc.png",
      description: `I had the thrilling experience of being part of the winning team at the 2019 RSPC Hackathon, a fast-paced 2-hour competition that pushed our abilities to their limits. We chose Java, a language we were confident and skilled in to do the competition in.

       The challenge was not just in coding, but in developing an innovative solution within a very limited time frame. Despite the pressures of time, we successfully solved all problems set in front of us with flying colors. Our win was not just a testament to our technical abilities in Java, but also our team coordination, quick decision-making, and capacity to innovate under pressure.`,
   },
];
